module.exports = __webpack_public_path__ + "img/srt341.17926cb3.png";